module.exports = __webpack_public_path__ + "img/logo.ea530c81.png";